<!-- Barra de menu-->
<navbar-component></navbar-component>

<main class="background">

    <!-- Cabeçalho -->
    <div class="head">
        <img src="./../../assets/icons/arquivos_head.svg" alt="Ícone Biblioteca" id="head-icon">
        <div class="container-title">
            <div class="title">
                Biblioteca
            </div>
        </div>
    </div>

    <div class="container">
        <!-- Corpo do conteúdo da página -->
        <div class="retangulo2">

            <!-- Título -->
            <div class="divider"></div>
            <div class="section">
                <h5>Artigos</h5>
                <div class="row">

                    <!-- Card 1 -->
                    <div class="col s12 m4 l4">
                        <div class="card">
                            <div class="card-image">
                                <img src="../../../../assets/fotos/capa-artigo1.png">
                            </div>
                            <div class="card-content">
                                <span class="card-title">The Requalification Possibility of Laundry Txtile Residues</span>
                                <p>The jeans finishing process seeks to improve it through chemical and physical processes. Therefore, numberless waste is generated and later dumped in the environment. (...)</p>
                            </div>
                            <div class="card-action">
                                <a
                                    href="https://drive.google.com/file/d/1FqRvEsQVUIKOwZS9KRhjMbVT0CE5UCoe/view?usp=sharing" id="card-action-link">Abrir
                                    documento</a>
                            </div>
                        </div>
                    </div>

                    <!-- Card 2 -->
                    <div class="col s12 m4 l4">
                        <div class="card">
                            <div class="card-image">
                                <img src="../../../../assets/fotos/capa-artigo2.png">
                            </div>
                            <div class="card-content">
                                <span class="card-title">A RENOVAÇÃO FUNCIONAL, ESTÉTICA E SIMBÓLICA DE
                                    FIBRILAS DE ALGODÃO DE LAVANDERIAS</span>
                                <p>O beneficiamento de tecidos gera inúmeros resíduos derivados de suas ações,
                                    como as fibrilas têxtis. Sendo seu volume significativo, a requalificação desses resíduos
                                    através de uma atividade produtiva sustentável...</p>
                            </div>
                            <div class="card-action">
                                <a
                                    href="https://drive.google.com/file/d/1s4m93mr9JaMCo3M6SzAM_AKjDr-y0GNT/view?usp=sharing" id="card-action-link">Abrir
                                    documento</a>
                            </div>
                        </div>
                    </div>

                    <!-- Card 3 -->
                    <div class="col s12 m4 l4">

                    </div>

                </div>
            </div>
            <div class="divider"></div>
            <div class="section">
                <h5>Livros</h5>
                <div class="row">

                    <!-- Card 1 -->
                    <div class="col s12 m4 l8">
                        <div class="card">
                            <div class="card-image">
                                <img src="../../../../assets/fotos/capa-livro1.png">
                            </div>
                            <div class="card-content">
                                <span class="card-title">Nutrientes Criativos: Resíduos de Confecções</span>
                                <p>Este livro é o relato do desenvolvimento do projeto
                                    cultural ‘Resíduos têxteis: nutrientes criativos’
                                    composto pela pesquisa na área de design e moda
                                    “Retransformação de resíduos têxteis: a construção
                                    de nova matéria-prima para artefatos de design e de
                                    moda”. (...)</p>
                            </div>
                            <div class="card-action">
                                <a
                                    href="https://drive.google.com/file/d/1CQLefUomUTESSkR77hFAZ0BPT_l85mhA/view?usp=sharing" id="card-action-link">Abrir
                                    documento</a>
                            </div>
                        </div>
                    </div>

                    <!-- Card 2 -->
                    <div class="col s12 m4 l2"></div>

                    <!-- Card 3 -->
                    <div class="col s12 m4 l2"></div>

                </div>
            </div>
            <div class="divider"></div>
            <div class="section">
                <h5>Manuais</h5>
                <div class="row">

                    <!-- Card 1 -->
                    <div class="col s12 m4 l8">
                        <div class="card">
                            <div class="card-image">
                                <img src="../../../../assets/fotos/capa-manual1.png">
                            </div>
                            <div class="card-content">
                                <span class="card-title">Cartilha Confecções</span>
                                <p>Esse cartilha é resultado do
                                    projeto cultural Resíduos Têxteis
                                    Nutrientes criativos e da Pesquisa
                                    Retransformação de resíduos
                                    têxteis: a construção de nova
                                    matéria-prima para artefatos de
                                    design e moda...</p>
                            </div>
                            <div class="card-action">
                                <a
                                    href="https://drive.google.com/file/d/1JQwdnEj9dkpcc72w82832gPWonLwTvoZ/view?usp=sharing" id="card-action-link">Abrir
                                    documento</a>
                            </div>
                        </div>
                    </div>

                    <!-- Card 2 -->
                    <div class="col s12 m4 l2">
                        
                    </div>

                    <!-- Card 3 -->
                    <div class="col s12 m4 l2">
                        
                    </div>

                </div>
            </div>

            <!-- FINAL - Corpo do conteúdo da página-->
        </div>
    </div>

</main>

<!-- Footer and copyright -->
<footer-component></footer-component>